
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c70a4cf6&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Customer.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Customer.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c70a4cf6!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Customer.vue"),
  /* scopeId */
  "data-v-c70a4cf6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Customer/Customer.vue
// module id = 690
// module chunks = 0